/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

// Legacy /configuration-agent route — redirects to the combined agent route.
// Kept for backward compatibility with bookmarks and external links.
export default class ConfigurationAgentIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: Transition) {
    super.beforeModel(transition);
    this.router.replaceWith('apps.app.automation.fin-ai-agent.ask', {
      queryParams: transition.to?.queryParams ?? {},
    });
  }
}
